import { messagePostService } from './messagePostService'

/**
 * The message-post module façade. No store: posts are always loaded per thread by the component
 * that shows them, so there is no shared state worth keeping.
 */
export const useMessagePost = () => {
  return {
    messagePost: {
      service: messagePostService()
    }
  }
}
